export default __webpack_public_path__ + "static/apple-touch-icon-0d40109453198b76bb6f83ac7672fef6.png";